import { Button, Input, Radio, Select } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

const TYPE_ALL = -1;
const TYPE_BOX = 2;
const TYPE_PRODUCT = 3;
const OWNERSHIP_ALL = -1;
const OWNERSHIP_OWNED = 1;
const OWNERSHIP_UNASSIGNED = 0;

const QrcodeDetailListHeader = ({
  keyword,
  setKeyword,
  typeFilter,
  setTypeFilter,
  ownershipFilter,
  setOwnershipFilter,
}) => {
  const history = useHistory();
  return (
    <div className="header">
      <div className="filters">
        <span className="filter-label">{i18n.t("qrcode.type")}:</span>
        <Select
          value={typeFilter}
          onChange={setTypeFilter}
          style={{ width: 140, marginRight: 16 }}
          optionLabelProp="label"
        >
          <Select.Option value={TYPE_ALL} label={i18n.t("qrcode.typeFilterAll")}>
            {i18n.t("qrcode.typeFilterAll")}
          </Select.Option>
          <Select.Option value={TYPE_BOX} label={i18n.t("qrcode.typeFilterBox")}>
            {i18n.t("qrcode.typeFilterBox")}
          </Select.Option>
          <Select.Option value={TYPE_PRODUCT} label={i18n.t("qrcode.typeFilterProduct")}>
            {i18n.t("qrcode.typeFilterProduct")}
          </Select.Option>
        </Select>
        <span className="filter-label">{i18n.t("qrcode.filterByOwnership")}:</span>
        <Radio.Group
          value={ownershipFilter}
          onChange={(e) => setOwnershipFilter(e.target.value)}
          style={{ marginRight: 16 }}
        >
          <Radio value={OWNERSHIP_ALL}>{i18n.t("qrcode.ownershipAll")}</Radio>
          <Radio value={OWNERSHIP_OWNED}>{i18n.t("qrcode.ownershipOwned")}</Radio>
          <Radio value={OWNERSHIP_UNASSIGNED}>{i18n.t("qrcode.ownershipUnassigned")}</Radio>
        </Radio.Group>
      </div>
      <div className="search">
        <Input
          value={keyword ?? ""}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder={i18n.t("qrcode.code")}
        />
        <Button type="primary">{i18n.t("common.search")}</Button>
      </div>
    </div>
  );
};
export default QrcodeDetailListHeader;
